export default function () {
    $.fn.heraldCenter = function () {
        this.css("position", "absolute");
        this.css("top", ($(this).parent().height() - this.height()) / 2 + "px");
        return this;
    };
}
